import { Button } from 'primereact/button';
import { FolderType, Fund } from './colDefsFundsTable';

export const RemoveSyncOptionCell = (props: { data: FolderType }) => {
  return (
    <>
      <Button
        label="Remove Sync"
        severity="warning"
        size="small"
        style={{ height: '28px' }}
        onClick={() => props.data.handleRemoveSync(props.data.id)}
      />
    </>
  );
};

export const AddFolderSyncOptionCell = (props: { data: Fund }) => {
  return (
    <>
      <Button
        label="Add Folder Sync"
        size="small"
        style={{ height: '28px' }}
        onClick={() => props.data.handleAddFolderSync(props.data.id)}
      />
    </>
  );
};
